import React from "react";
import styled from "styled-components"

const Styled={
    MenuRecommendBox:styled.div`
        width:32px;
        height:20px;
        margin-right:5px;
        border-radius:5px;
        background-color:#FFE3E3;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        MenuRecommendText:styled.p`
            font-size:10px;
            font-weight:400;
            color:#FF4444;
            font-family:'PreFont';
        `,
}

const Populal=()=>{
    return(
        <Styled.MenuRecommendBox>
            <Styled.MenuRecommendText>인기</Styled.MenuRecommendText>
        </Styled.MenuRecommendBox>
    )
}
export default Populal